<template>
  <div>
    <template v-if="itemList.length > 0 || scrollFlag">
      <div class="list_box">
        <Item v-for="item in itemList" :key="item.id" :details="item"> </Item>
      </div>
      <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
    </template>
    <NoData v-if="itemList.length == 0 && !scrollFlag" :marginTop="'100px'"></NoData>
  </div>
</template>
    
<script>
import Item from "@/components/pager/courseItme";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
import mixin from "@/mixins/scrollPager";
export default {
  components: {
    Item,
    Scroll,
    NoData,
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        companyId: this.$route.query.id,
        pageNo: 1,
        pageSize: 6,
        userType: 1,
      },
    };
  },
  created() {
    // 论文列表
    this.getList(this.params);
  },
  methods: {
    async getList(params) {
      this.scrollFlag = true;
      const resp = await this.$apis.hundredServe.getBkCourseList(params);
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      this.isEnd = this.pageNum >= this.total / 6;
    },
  },
};
</script>
    
    <style scoped lang="scss">
.list_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 45px 0 30px;
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  &:after {
    content: "";
    width: 380px;
  }
}
</style>